module.exports = __webpack_public_path__ + "img/ic_company-logo_01.213748c7.svg";